module.exports = __webpack_public_path__ + "static/media/product-4-back.7336a736.jpg";